module.exports = __webpack_public_path__ + "img/apidays-2021-snapshot-2.39f1df19.jpg";